import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [careersOpen, setCareersOpen] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="brand footer-brand">
          <span className="brand-mark">●</span> Bellboy
        </div>
        <div className="footer-links">
          <Link to="/why">Why</Link>
          <Link to="/product">Product</Link>
          <Link to="/market">Market</Link>
          <Link to="/approach">Approach</Link>
          <Link to="/about">About</Link>
          <button
            className="footer-link-btn"
            aria-expanded={careersOpen}
            aria-controls="careers-box"
            onClick={() => setCareersOpen((o) => !o)}
          >
            Careers
          </button>
          <span className="footer-divider">|</span>
          <div className="footer-socials">
            <a href="https://www.instagram.com/bellboy_india" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              Instagram
            </a>
            <a href="https://www.facebook.com/profile.php?id=61594219675542" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              Facebook
            </a>
            <a href="https://x.com/BellBoy_India" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              Twitter
            </a>
            <a href="https://www.linkedin.com/company/bellboy-residential-technologies/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              LinkedIn
            </a>
          </div>
        </div>
      </div>
      <div id="careers-box" className={`careers-box ${careersOpen ? "is-open" : ""}`}>
        <strong>We're hiring, informally.</strong> Bellboy is pre-seed and small — if you want in, send your
        resume and a note on what you'd want to work on to{" "}
        <a href="mailto:tejeshwarmishra1@gmail.com">tejeshwarmishra1@gmail.com</a>.
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Bellboy. All rights reserved.</span>
        <span className="footer-dot">•</span>
        <span>Pre-seed startup</span>
        <span className="footer-dot">•</span>
        <span>Founder: Tejeshwar Mishra</span>
      </div>
    </footer>
  );
}
